import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCustomerServiceManagementFeedbackRoute: InvariantJiraRoute = {
	name: 'project-settings-customer-service-management-feedback',
	path: '/jira/customer-service-management/projects/:projectKey/settings/feedback-settings',
};
